import React, {useEffect, useState} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {alertaDeErro, alertaDeSucesso} from "../../services/alertServices";

export const ModalCriarJogador = ({isOpen, toggle, onJogadorCriado}) => {
    const [nome, setNome] = useState('');
    const [foto, setFoto] = useState(null);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setNome('');
            setFoto(null);
        }
    }, [isOpen]);

    const handleFotoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFoto(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSalvar = async () => {
        if (!nome || nome.trim().length < 2) {
            await alertaDeErro('O nome do jogador deve ter pelo menos 2 caracteres.');
            return;
        }

        try {
            setSalvando(true);
            const response = await fetch('/api/Jogadores', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    nome: nome,
                    fotoUrl: foto
                })
            });

            if (!response.ok) {
                throw new Error('Erro ao salvar jogador');
            }

            const novoJogador = await response.json();

            await alertaDeSucesso('Jogador cadastrado com sucesso!');

            // Passa o objeto criado para o componente pai atualizar a lista localmente se quiser
            if (onJogadorCriado) {
                await onJogadorCriado(novoJogador);
            }

            toggle();

        } catch (e) {
            console.error(e);
            await alertaDeErro('Não foi possível cadastrar o jogador.');
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Novo Jogador</ModalHeader>
            <ModalBody>
                <div className="text-center mb-3">
                    {foto ? (
                        <img
                            src={foto}
                            alt="Preview"
                            className="rounded-circle border shadow-sm"
                            style={{width: '100px', height: '100px', objectFit: 'cover'}}
                        />
                    ) : (
                        <div
                            className="rounded-circle border bg-light d-flex align-items-center justify-content-center mx-auto"
                            style={{width: '100px', height: '100px'}}
                        >
                            <span className="text-muted small">Sem foto</span>
                        </div>
                    )}
                </div>

                <div className="mb-3">
                    <label htmlFor="foto" className="form-label">Foto (Opcional)</label>
                    <input
                        type="file"
                        accept="image/*"
                        className="form-control"
                        id="foto"
                        onChange={handleFotoChange}
                    />
                    <div className="form-text">Tire uma foto ou escolha da galeria.</div>
                </div>

                <div className="mb-3">
                    <label htmlFor="nomeJogador" className="form-label">Nome do Jogador</label>
                    <input
                        type="text"
                        className="form-control form-control-lg"
                        id="nomeJogador"
                        placeholder="Ex: João Silva"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleSalvar()}
                        autoFocus
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary" onClick={toggle}>
                    Cancelar
                </button>
                <button
                    className="btn btn-success"
                    onClick={handleSalvar}
                    disabled={salvando}
                >
                    {salvando ? 'Salvando...' : 'Salvar'}
                </button>
            </ModalFooter>
        </Modal>
    );
};